<template>
  <ClassroomPageLayout activeIndex="1" :className="$store.state.className">
    <router-view></router-view>
  </ClassroomPageLayout>
</template>

<script>
import ClassroomPageLayout from "@/layouts/ClassroomPageLayout.vue";

export default {
  name: "Classroom",
  components: {
    ClassroomPageLayout
  },
};
</script>

<style scoped>
</style>